import { useNoPhoneCodes } from "Flocknote/stateHooks";

import { useTwoFAContext } from "Login/TwoFA/TwoFA";
import { variants } from "Login/TwoFA/constants";

const useFirstFactorVerbiage = () => {
  const { variant, firstFactorPrompt } = useTwoFAContext();
  const noPhoneCodes = useNoPhoneCodes();

  if (firstFactorPrompt) return firstFactorPrompt;

  switch (variant) {
    case variants.login:
      if (noPhoneCodes) return "Enter your email to log in.";
      return "Enter your email or phone number to log in.";
    case variants.give:
      return "Let's verify your info";
    default:
      return "";
  }
};

export { useFirstFactorVerbiage };
